export const LOAD_CATEGORY = 'LOAD_CATEGORY'
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY'
